module.exports = {
    methods: {
        hasErrors(field, value) {
            if (value[field] && value[field].length > 0) {
                return false;
            }
        }
    }
};
